import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import { personnelsService } from '../../_services/personnels.service'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

class AsyncPersonnelSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      defaultValue: '',
      data: [],
      selected: this.props.defaultValue ? this.props.defaultValue : [],
    };
  }

  componentWillMount() {
    this.getData();
  }

  getData() {
    this.setState({ loading: true });
    personnelsService.getAll()
      .then((res) => {
        // // console.log(res.data)
        let data = res.data.map(elm => ({ "label": elm.fullName, "value": elm.id }))
        this.setState({ data: data, loading: false, isSubmitting: false });
      })
  };

  handleChange = e => {

    if (this.props.isMulti) {
      var selected = [].slice
        .call(e)
        .map(option => option.value)
      this.setState({ "selected": selected })
      this.props.onChange(selected);
    } else {
      this.props.onChange(e.value);
    }

  }

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,

      }),
      control: (provided) => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#f6f6f6',
        borderRadius: 20,
        // height: 40,
        boxShadow: 'none',
        border: 'none',
        paddingRight: '12',
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),
      multiValue: (styles, { data }) => {
        return {
          ...styles,
          backgroundColor: '#6F64F8',
          borderRadius: 25,
          color: '#fff',
          padding: '2px 10px'
        };
      },
      multiValueLabel: (styles, { data }) => ({
        ...styles,
        color: '#fff',
        padding: 1,
      }),
      multiValueRemove: (styles, { data }) => ({
        ...styles,
        color: data.color,
        ':hover': {
          backgroundColor: data.color,
          color: 'white',
        },
      }),

    }
    const { loading, data, selected } = this.state;
    const { disabled, required, isMulti, closeMenuOnSelect } = this.props;

    return (
      <ReactSelect
        placeholder=""
        styles={customStyles}
        value={isMulti ? data.filter(o => selected.includes(o.value)) : data.filter(o => selected.includes(o.value))[0]}
        //  error={errors.selected}
        //  touched={touched.selected}
        //  onChange={evt =>
        //    {// console.log(evt);
        //    this.setState({
        //      "selected":
        //      [].slice
        //        .call(evt)
        //        .map(option => option.value)
        //    })
        // }}
        closeMenuOnSelect={closeMenuOnSelect}
        onChange={val => this.handleChange(val)}
        isMulti={isMulti}
        options={data}
        className={required ? "select required" : "select"}
        noOptionsMessage={() => "نتیجه ای یافت نشد"}
        loadingMessage={() => "در حال دریافت اطلاعات از سرور"}
        isLoading={loading}
      />
    );
  }
}
export default AsyncPersonnelSelect;
